import React, { useState } from "react";
import Modal from 'react-modal';
 
interface ZoomableImageModalProps {
  isOpen: boolean;
  src: string;
  onClose: () => void;
}
 
export const ZoomableImageModal: React.FC<ZoomableImageModalProps> = ({ isOpen, src, onClose }) => {
    Modal.setAppElement("#root");
    const [scale, setScale] = useState(1);
    
    const zoomIn = (e: any) => {
        e.preventDefault();
        setScale((prev) => prev + 0.2)
    };
    const zoomOut = (e: any) => {
        e.preventDefault();
        setScale((prev) => Math.max(0.5, prev - 0.2));
    };
    const resetZoom = () => setScale(1);
 
    if (!isOpen) return null;
 
    return (
         <Modal isOpen={isOpen}>
                <div className="modale open">
                  <div className="modale--content">
                  <div className="p-md bg-blanc" style={{position: "relative"}}>
                        <div className="zoom-bloc-image">
                            <button
                                onClick={zoomIn}
                                disabled={scale === 2}
                            >
                                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/zoom_in.svg"} style={{boxShadow: "none"}} alt=''/>
                            </button>
                            <button
                                onClick={zoomOut}
                                disabled={scale === 1}
                            >
                                <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/zoom_out.svg"} style={{boxShadow: "none"}} alt=''/>
                            </button>
                        </div>     
                    <div className="p-md ta-center image-modal" style={{overflow: "auto"}}>            
                        <img
                            src={src}
                            alt="Zoomable"
                            style={{
                                transform: `scale(${scale})`,
                                transition: "transform 0.2s ease-in-out",
                                maxHeight: "80vh",
                                boxShadow: "none"
                            }}
                        />
                    </div>  
                    <div className="ta-center">
                        <button className="cta-bleu cta-small ml-x-md mt-lg" onClick={onClose}>Fermer</button>           
                    </div>  
                    </div>
                  </div>
                </div>
              </Modal>

  );
};